import React, { useState } from "react";
import TopFiveSectionTemplate_Coral from "./TopFiveSectionTemplate_Coral";

function TableSection_Coral(props) {
  let { gloablfilter } = props;
  const singleVinSelected = (vin) => {
    props.singleVinSelected(vin);
  };

  const [isDropdownVisible, setDropdownVisible] = useState(false);

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
  };

  return (
    <>
      <div
        className={
          isDropdownVisible === true
            ? "row ml-0 mb-0 mt-1 d-flex align-items-center drive_table_div"
            : "row ml-0 mb-3 mt-1 d-flex align-items-center drive_table_div"
        }
        // style={{
        //   height: "40px",
        //   width: "100%",
        //   backgroundColor: "#fff",
        //   boxShadow: "rgba(0, 0, 0, 0.35) 0px 1px 4px",
        //   position: "relative",
        // }}
        onClick={toggleDropdown}
      >
        <h5 className="text-start mt-2" style={{ color: "#625959" }}>
          Top/Bottom Performing Vehicles
        </h5>
        <img
          className="ml-auto text-end dropdown_img"
          src={
            isDropdownVisible
              ? "/assets/img/up_arrow.png" // Image when dropdown is open
              : "/assets/img/down_arrow.png"
          }
          // style={{
          //   height: "28px",
          //   width: "47px",
          //   cursor: "pointer",
          //   position: "absolute",
          //   right: "10px",
          //   top: "50%",
          //   transform: "translateY(-50%)",
          // }}
          alt=""
          // onClick={toggleDropdown}
        />
      </div>

      {isDropdownVisible && (
        <div
          className="row mb-3 ml-0 dropdown_div"
          style={{
            // height: "250px",
            width: "100%",
            // backgroundColor: "#f8f8f8",
            marginTop: "-10px", // Adjust as needed
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "0 0 4px 4px",
            padding: "10px",
            backgroundColor: "#e7e7e7",
          }}
        >
          <div className="col-md-6 pt-2 px-4">
            <TopFiveSectionTemplate_Coral
              gloablfilter={gloablfilter}
              singleVinSelected={singleVinSelected}
              IND="RANGE"
              title=" 10 Range Vehicles"
              template_id="collapseOne"
              show={true}
              soarting={true}
            ></TopFiveSectionTemplate_Coral>
          </div>
          <div className="col-md-6 pt-2 px-4">
            <TopFiveSectionTemplate_Coral
              gloablfilter={gloablfilter}
              singleVinSelected={singleVinSelected}
              IND="WHR"
              title=" 10 Wh/km Discharge "
              template_id="collapseTwo"
              show={true}
              soarting={true}
            ></TopFiveSectionTemplate_Coral>
          </div>
         
        </div>
      )}
    </>
  );
}

export default TableSection_Coral;
